import React, { useState } from "react";
import { apiFetch, setToken } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Loader2, Lock, Mail } from "lucide-react";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("admin@puresouls.com.au");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password || loading) return;
    setLoading(true);
    try {
      const res = await apiFetch(`${BACKEND_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim(), password }),
      });
      const data = await res.json();
      if (res.ok && data.token) {
        setToken(data.token);
        toast.success("Welcome back");
        onLogin(data.user);
      } else {
        toast.error(typeof data.detail === "string" ? data.detail : "Login failed");
      }
    } catch (err) {
      toast.error("Could not connect. Please try again.");
    }
    setLoading(false);
  };

  return (
    <div
      className="min-h-screen bg-background flex items-center justify-center px-5 py-10"
      data-testid="login-screen"
    >
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img
            src="/pure-souls-logo.svg"
            alt="Pure Souls"
            className="h-14 w-auto mx-auto mb-4"
          />
          <h1 className="text-3xl sm:text-4xl font-serif font-medium text-foreground">
            Email Hub
          </h1>
          <p className="text-sm text-muted-foreground mt-1.5">
            Sign in to your AI Email Portal
          </p>
        </div>

        <form
          onSubmit={submit}
          className="bg-card border border-border rounded-3xl shadow-sm p-7 space-y-4"
        >
          <div className="space-y-1.5">
            <label className="text-xs font-semibold text-muted-foreground">Email</label>
            <div className="relative">
              <Mail className="w-4 h-4 text-muted-foreground absolute left-3.5 top-1/2 -translate-y-1/2" />
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@puresouls.com.au"
                className="pl-10 h-11 rounded-full"
                data-testid="login-email-input"
                autoComplete="username"
              />
            </div>
          </div>

          <div className="space-y-1.5">
            <label className="text-xs font-semibold text-muted-foreground">Password</label>
            <div className="relative">
              <Lock className="w-4 h-4 text-muted-foreground absolute left-3.5 top-1/2 -translate-y-1/2" />
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                className="pl-10 h-11 rounded-full"
                data-testid="login-password-input"
                autoComplete="current-password"
              />
            </div>
          </div>

          <Button
            type="submit"
            disabled={loading || !email.trim() || !password}
            data-testid="login-submit-btn"
            className="w-full h-11 text-base bg-primary text-primary-foreground hover:bg-accent rounded-full shadow-sm"
          >
            {loading ? (
              <>
                <Loader2 className="w-5 h-5 mr-2 animate-spin" /> Signing in...
              </>
            ) : (
              "Sign In"
            )}
          </Button>
        </form>

        <p className="text-center text-xs text-muted-foreground mt-6">
          Pure Souls Pet Aqua Cremation · Staff access only
        </p>
      </div>
    </div>
  );
}
